export default __webpack_public_path__ + "media/images/mailer-new/heading/archive-2c8fa5362617c1e8c1d28462847d8d1c.png";